import { render, staticRenderFns } from "./appointmentschedulecenter.vue?vue&type=template&id=3c8dad9f&scoped=true"
import script from "./appointmentschedulecenter.vue?vue&type=script&lang=js"
export * from "./appointmentschedulecenter.vue?vue&type=script&lang=js"
import style0 from "./appointmentschedulecenter.vue?vue&type=style&index=0&id=3c8dad9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8dad9f",
  null
  
)

export default component.exports